var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gosser-main"},[_c('Hero'),_c('About'),_c('Quotes'),_c('Video',{attrs:{"video":'Gosser_DAN22HNKGSR0130.mp4',"poster":'gosser_preview.jpg'}}),_c('Products'),_c('Premium'),_c('Responsibility'),_c('Contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }